import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindSessionsParams = {
  userId: number;
  filters: Record<string, any>;
};

const { useFind: useUserSessions } = getCRUDHooks({
  entityName: 'userSession',
  find: ({ userId, filters }: FindSessionsParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).sessions.find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useUserSessions };
